import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

/**
 * Universal confirm-delete dialog used everywhere a destructive action is fired.
 * Iter 9.47.q - Single confirm button (no type-to-confirm).
 *
 * Usage:
 *   const [target, setTarget] = useState(null);
 *   <ConfirmDeleteDialog
 *     open={!!target}
 *     onOpenChange={(o) => !o && setTarget(null)}
 *     itemLabel={target?.name}
 *     onConfirm={async () => { await deleteFn(target.id); setTarget(null); }}
 *   />
 */
export default function ConfirmDeleteDialog({
  open,
  onOpenChange,
  title = "Delete this item?",
  description,
  itemLabel,
  confirmLabel = "Delete",
  cancelLabel = "Cancel",
  onConfirm,
  loading = false,
}) {
  const finalDescription =
    description ||
    (itemLabel
      ? `This will permanently remove "${itemLabel}". This action cannot be undone.`
      : "This action cannot be undone.");

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="confirm-delete-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle data-testid="confirm-delete-title">{title}</AlertDialogTitle>
          <AlertDialogDescription data-testid="confirm-delete-description">
            {finalDescription}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="confirm-delete-cancel" disabled={loading}>
            {cancelLabel}
          </AlertDialogCancel>
          <AlertDialogAction
            data-testid="confirm-delete-confirm"
            onClick={(e) => {
              e.preventDefault();
              if (!loading) onConfirm?.();
            }}
            disabled={loading}
            className="bg-red-600 hover:bg-red-700 focus:ring-red-600"
          >
            {loading ? "Deleting..." : confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
